var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-info"},[_c('h4',{staticClass:"text-red"},[_vm._v("No data to display.")]),_vm._v(" "),_c('p',[_vm._v("Please enter the search criteria and click the search button.")]),_vm._v(" "),_c('p',[_c('i',{staticClass:"fa fa-exclamation-triangle"}),_vm._v("\n    The broader the search criteria, the longer it takes to show results.\n  ")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/common/NoDataMessage.vue